<template>
  <div>
    <v-card v-if="loading" outlined class="rounded-lg pa-4">
      <v-skeleton-loader type="heading, text, text" />
    </v-card>

    <v-card v-else-if="outage" class="outage-hero rounded-lg ordera-box-shadow" flat>
      <div class="outage-hero__accent"></div>
      <div class="outage-hero__body">
        <div class="d-flex align-center flex-wrap" style="gap: 10px">
          <div class="outage-hero__live">
            <span class="outage-hero__dot"></span>
            {{ $t("outage_status_active") }}
          </div>
          <v-chip
            v-if="daysActive >= warningDays"
            color="warning"
            text-color="white"
            x-small
            label
          >
            <v-icon left x-small>mdi-alert</v-icon>
            {{ $t("outage_days_count", { days: daysActive }) }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            text
            small
            color="error"
            :loading="deactivating"
            @click="$emit('deactivate')"
          >
            <v-icon left small>mdi-bell-off-outline</v-icon>
            {{ $t("deactivate") }}
          </v-btn>
        </div>

        <div class="outage-hero__title mt-2">
          {{ outage.title || $t("outage_important_notice") }}
        </div>
        <div class="outage-hero__message">{{ outage.message }}</div>

        <div class="outage-hero__meta mt-3">
          <v-icon x-small>mdi-clock-outline</v-icon>
          {{ $t("outage_published_on", { date: formatOutageDate(outage.created_at) }) }}
          <template v-if="daysActive >= warningDays">
            · {{ $t("outage_active_days_warning", { days: daysActive }) }}
          </template>
        </div>
      </div>
    </v-card>

    <v-card v-else outlined class="outage-hero outage-hero--calm rounded-lg">
      <div class="d-flex align-center px-5 py-4" style="gap: 12px">
        <v-icon color="success">mdi-check-circle-outline</v-icon>
        <span class="text-body-2 grey--text text--darken-1">{{ $t("outage_none_active") }}</span>
      </div>
    </v-card>
  </div>
</template>

<script>
import hasOutageDate from "@/mixins/hasOutageDate";

export default {
  name: "OutageStatusBanner",
  mixins: [hasOutageDate],
  props: {
    outage: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    deactivating: {
      type: Boolean,
      default: false,
    },
    warningDays: {
      type: Number,
      default: 7,
    },
  },
  computed: {
    daysActive() {
      return this.outage ? this.outageDaysActive(this.outage.created_at) : 0;
    },
  },
};
</script>

<style scoped>
.outage-hero {
  position: relative;
  display: flex;
  overflow: hidden;
}

.outage-hero__accent {
  width: 6px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #ff9800 0%, #d32f2f 100%);
}

.outage-hero__body {
  padding: 18px 22px;
  flex: 1;
  min-width: 0;
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.07), rgba(255, 152, 0, 0) 55%);
}

.outage-hero__live {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: 0.78rem;
  color: #e65100;
}

.outage-hero__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fb8c00;
  animation: outage-pulse 1.8s infinite;
}

@keyframes outage-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0.55);
  }
  70% {
    box-shadow: 0 0 0 9px rgba(251, 140, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0);
  }
}

.outage-hero__title {
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1.3;
}

.outage-hero__message {
  white-space: pre-line;
  color: rgba(0, 0, 0, 0.68);
  margin-top: 2px;
}

.outage-hero__meta {
  font-size: 0.78rem;
  color: rgba(0, 0, 0, 0.5);
}

.outage-hero--calm {
  border-style: dashed;
}
</style>
